<template>
  <div class="question-content">
    <topic-content-header
      :checkShow="checkShow"
      :length="showQuestionList.length"
      :pitchOnLength="Number(pitchOnLength)"
      @changeArrange="changeArrange"
      />
    <nav >
      <li :id="'#' + item.question_id" v-for="(item, index) in showQuestionList" :key="index">
        <div v-if="item.question_title_uuid === '' " class="content">
          <!-- 知识点 -->
          <span class="content__title"
            v-for="(Kitem, kindex) in item.knowledge_codes"
            :key="kindex">{{ Kitem.tag_name }}</span>
            <!-- 题干 -->
          <div class="content__count">
            <p>{{ index + 1 }}、</p>
            <p
              v-if="scienceArr.includes(Number(overviewData.subject_id))"
              v-katexHtml="item.title" />
              <p v-katexUbb="htmlDeCode(item.title)" v-else />
          </div>
          <!-- 英语听力 -->
          <div
            class="content__audio"
            v-if="
              item.content &&
              item.content.hearing &&
              item.content.hearing[0] &&
              item.content.hearing[0].source
            "
            @click="controlAudio(item.question_id)"
          >
            <p
              class="audio-pause"
              :class="
                isAudioPlaying &&
                currentQuestionUuid === qItem.question_uuid?
                'voice-playing' : ''"
            ></p>
            <audio
              ref="audio"
              :id="`audio${item.question_id}`"
              :src="item.content.hearing[0].source"
              @pause="onPause"
              @play="onPlay"
            />
          </div>
          <!-- 判断题 -->
          <div
            v-if="item.question_type === 3 && item.show_type  === '103'"
            class="content__option"
          >
            <div
              v-for="(oitem, oindex) in Number(overviewData.subject_id) === 1
                ? enText
                : cnText"
              :key="oindex"
            >
              <p>{{ oitem }}</p>
            </div>
          </div>
          <!-- 选择按钮 -->
          <img src="~@/views/pt/images/CheckBox-empty.png"
            @click="pitchOn(item)"
            v-if="checkShow && !item.checkActive"
            class="question-content__check">
            <!-- 取消选择 -->
          <img src="~@/views/pt/images/pitch-on.png"
            v-if="checkShow && item.checkActive"
            @click="callOff(item)"
            class="question-content__check">
          <!-- 所有答案 -->
          <div class="question-analysis__option">
            <div v-for="(oitem, oindex) in item.options" :key="oindex">
              <p v-if="oitem.key">{{ oitem.key }}：</p>
              <p v-katexHtml="oitem.content"></p>
            </div>
          </div>
          <!-- 选词填空 -->
          <div
            v-if="
              item &&
              item.question_type === 6
            "
            class="content__option"
          >
            <div
              v-for="(oitem, oindex) in item.choice_words"
              :key="oindex"
            >
              <p class="judge" v-katexUbb="htmlDeCode(oitem.content)"></p>
            </div>
          </div>
          <div class="content__footer">
            <div>
              <p>
                <span>题型: </span>
                <span>{{ questionName(
                      item.question_type,
                      item.show_type,
                      item.question_title_uuid,) || item.question_type_name }}</span>
              </p>
              <p>
                <span>难度: </span>
                <span>{{ item.difficulty }}</span>
              </p>
              <p>
                <span>正答率: </span>
                <span>{{ item.right_rate }}%</span>
              </p>
            </div>
            <div class="footer__right">
              <p class="analysis pointer">
                <span
                  v-if="item.active"
                  style="margin-left: 6px"
                  @click="closeAnalysis(item)"
                  >收起统计</span
                >
                <span
                  v-else
                  style="margin-left: 6px"
                  @click="openAnalysis(item)"
                  >答题统计</span
                >
              </p>
            </div>
          </div>
        </div>
        <!-- 题冒题 -->
        <div v-else>
          <!-- 题冒题 -->
          <ul>
            <li class="content">
              <div class="content__count">
                <div v-if="item.questionList.title_question
                && item.questionList.title_question.content">
                <el-popover
                  placement="right"
                  title=""
                  popper-class="popover"
                  width="600"
                  @hide="hide"
                  trigger="click"
                  content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                  <p
                    v-if="scienceArr.includes(Number(overviewData.subject_id))"
                    v-katexHtml="item.questionList.title_question.content.content" />
                    <p
                      v-katexUbb="htmlDeCode(item.questionList.title_question.content.content)"
                      v-else />
                  <!-- 英语听力 -->
                  <div
                    class="content__audio"
                    v-if="
                      item.questionList &&
                      item.questionList.title_question &&
                      item.questionList.title_question.content &&
                      item.questionList.title_question.content.hearing&&
                      item.questionList.title_question.content.hearing[0] &&
                      item.questionList.title_question.content.hearing[0].source
                    "
                    @click="controlAudio(item.question_id)"
                  >
                    <p
                      class="audio-pause"
                      :class="
                        isAudioPlaying &&
                        currentQuestionUuid === qItem.question_uuid ?
                        'voice-playing' : ''"
                    ></p>
                    <audio
                      ref="audio"
                      :id="`audio${item.question_id}`"
                      :src="item.questionList.title_question.content.hearing[0].source"
                      @pause="onPause"
                      @play="onPlay"
                    />
                  </div>
                  <p slot="reference" class="pointer title-uuid">查看原文</p>
                </el-popover>
                  <p style="display: inline-block;">{{ index + 1 }}、</p>
                  <p style="display: inline-block;"
                  v-katexUbb="htmlDeCode(item.questionList.content.content)" />
                </div>
              </div>
              <!-- 选择按钮 -->
                <p
                  v-if="checkShow && !item.checkActive"
                  class="question-content__check location"> 该题型暂不支持布置 </p>
                  <!-- 取消选择 -->
                <img src="~@/views/pt/images/pitch-on.png"
                  v-if="checkShow && item.checkActive"
                  @click="callOff(item)"
                  class="question-content__check">
              <!-- 选词填空 -->
              <div
                v-if="
                  item.questionList &&
                  item.questionList.question_type === 6
                "
                class="content__option"
              >
                <div v-for="(oitem, oindex) in item.questionList.choice_words" :key="oindex">
                  <p class="judge" v-katexUbb="htmlDeCode(oitem.content)"></p>
                </div>
              </div>
              <!-- 判断题 -->
              <div
                v-if="
                  item.questionList &&
                  item.questionList.question_type === 3 &&
                  item.questionList.show_type === '103'
                "
                class="content__option"
              >
                <div v-for="(oitem, oindex) in Number(overviewData.subject_id) === 1
                ? enText
                : cnText" :key="oindex">
                  <p>{{ oitem }}</p>
                </div>
              </div>
              <div class="content__option" v-else>
                <div v-for="(oitem, oindex) in item.questionList.options" :key="oindex">
                  <p>{{ oitem.key }}：</p>
                  <p v-katexHtml="oitem.content"></p>
                </div>
              </div>
              <div class="content__footer">
                <div>
                  <p>
                    <span>题型: </span>
                    <span>{{ questionName(
                      item.questionList.question_type,
                      item.questionList.show_type,
                      item.question_title_uuid,) }}</span>
                  </p>
                  <p>
                    <span>难度: </span>
                    <span>{{ item.questionList.difficulty }}</span>
                  </p>
                  <p>
                    <span>正答率: </span>
                    <span>{{ item.right_rate }}%</span>
                  </p>
                </div>
                <div class="footer__right">
              <p class="analysis pointer">
                <span
                  v-if="item.active"
                  style="margin-left: 6px"
                  @click="closeAnalysis(item)"
                  >收起统计</span
                >
                <span
                  v-else
                  style="margin-left: 6px"
                  @click="openAnalysis(item)"
                  >答题统计</span
                >
              </p>
              </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- 展开解析 -->
        <ul class="question-analysis" v-if="item.active">
          <li class="question-analysis__answer">
            <span style="min-width: 110px">正确答案:</span>
            <!-- 理科正确答案 -->
            <div v-if="scienceArr.includes(Number(overviewData.subject_id))">
              <div v-if="item.question_type !== 3">
                <span
                  v-for="(aitem, aindex) in item.answer"
                  :key="aindex"
                  class="right-answer"
                  v-katexHtml="aitem"
                ></span>
              </div>
              <div v-else class="completion">
                <div v-for="(aitem, aindex) in item.answer" :key="aindex">
                  <div
                    v-for="(childItem, childIndex) in aitem"
                    :key="childIndex"
                  >
                    <span
                      v-katexHtml="childItem.content"
                      class="right-answer"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 文科 -->
            <div v-else>
              <p v-if="item.question_type !== 3 && item.question_type !== 6 ">
              <span
                v-for="(aitem, aindex) in item.answer"
                :key="aindex"
                class="right-answer"
                v-katexUbb="htmlDeCode(aitem)"
              ></span>
              </p>
              <div v-else class="completion">
                <div v-if="item.question_type === 3 && (item.show_type
                || (item.questionList && item.questionList.show_type))  === '103'">
                  <div
                    v-for="(aitem, aindex) in item.answer"
                    :key="aindex"
                    class="right-answer">
                      <span v-if="Number(overviewData.subject_id) === 3">
                        {{ aitem.content === "T" ? "正确" : "错误" }}
                      </span>
                      <span v-else>
                        {{ aitem.content === "T" ? "True" : "False" }}
                      </span>
                  </div>
                </div>
                <div v-else v-for="(aitem, aindex) in item.answer" :key="aindex">
                  <div v-for="(childItem, childIndex) in aitem" :key="childIndex">
                    <span
                      v-katexUbb="htmlDeCode(childItem.content)"
                      class="right-answer"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li
            v-if="item.detailsList &&
            item.detailsList[0] &&
            item.detailsList[0].list &&
            item.detailsList[0].list.length > 0
          ">
            <div class="error-topic">
              {{(item.question_type === 1 || (item.question_type === 3 && item.show_type === '103'))
               ? '' :
              `共性错题top5 ( 总人数: ${item.allTotalCnt} 人, 总答错人数: ${item.allWrongCnt} 人 )`}}
            </div>
            <!-- 单选错误答案 -->
            <ul v-if="item.question_type === 1 ||
               (item.question_type === 3 && item.show_type === '103')">
              <li class="error">
                <div class="error-label">
                  作答情况:
                </div>
                <div style="flex: 1;">
                  <div>( 总人数: {{item.allTotalCnt}} 人, 总答错人数: {{item.allWrongCnt}} 人 )</div>
                  <div
                    v-for="(kitem, index) in item.detailsList"
                    :key="index"
                    class="error-answer">
                    <div v-if="item.question_type === 3 && item.show_type === '103'">
                      <div
                        v-for="(uitem, uindex) in kitem.userAnswer"
                        :key="uindex"
                        class="right-answer">
                        <div v-if="uitem !== ''">
                          <span v-if="Number(overviewData.subject_id) === 3">
                            {{ uitem === "T" ? "正确" : "错误" }}
                          </span>
                          <span v-else>
                            {{ uitem === "T" ? "True" : "False" }}
                          </span>
                        </div>
                        <div v-else>
                          未作答
                        </div>
                      </div>
                    </div>
                    <span v-else class="mr fx-1">选项[{{kitem.userAnswer !== '' ?
                      kitem.userAnswer : '未作答'}}]</span>
                    <span class="mr fx-1">占{{kitem.wrongRat }}%</span>
                    <div style="width: 60%">
                      <el-progress
                      :percentage="kitem.wrongRat "
                      :color="customColor"></el-progress>
                    </div>
                    <i v-if="!kitem.isShow"
                      class="el-icon-arrow-down"
                      @click="openStudent(kitem)"></i>
                    <i v-else class="el-icon-arrow-up" @click="openStudent(kitem, true)"></i>
                    <div style="width: 100%"></div>
                    <div div v-if="kitem.isShow" class="error-student">
                      <i class="el-icon-caret-top top"></i>
                      <span v-for="(student, studentIndex) in kitem.list" :key="studentIndex">
                        {{student.studentName}}
                        <span v-if="studentIndex < kitem.list.length -1">|</span>
                      </span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <!-- 填空题错误答案渲染 -->
            <el-table
              v-else
              :data="item.detailsList"
              style="width: 90%">
              <el-table-column
                prop="userAnswer"
                label="错误答案">
                <template slot-scope="scope">
                  <!-- 理科错题 -->
                  <div v-if="scienceArr.includes(Number(overviewData.subject_id))">
                    <div v-if="!scope.row.userAnswer.length">
                      跳过此题
                    </div>
                    <span
                      v-else
                      v-for="(item, index) in scope.row.userAnswer"
                      :key="index"
                      v-katexHtml='item'>
                    </span>
                  </div>
                  <!-- 文科错题 -->
                  <div v-else>
                    <div >
                      <span
                      v-for="(uitem, index) in scope.row.userAnswer"
                      :key="index">
                        <span
                          style="margin-left: 4px;"
                          v-if="uitem !== ''"
                          v-katexUbb="htmlDeCode(uitem)"></span>
                        <span v-else> 未作答 </span>
                      </span>
                    </div>
                  </div>
              </template>
              </el-table-column>
              <el-table-column
                prop="wrongCnt"
                align="center"
                label="答错人数">
              </el-table-column>
              <el-table-column
                prop="error_than"
                align="center"
                label="占比数据">
                <template slot-scope="scope">
                <div>
                  {{ Math.floor(scope.row.wrongRat) }}%
                </div>
              </template>
              </el-table-column>
              <el-table-column
                prop="list"
                align="center"
                width="500"
                label="学生明细">
                <template slot-scope="scope">
                  <span v-for="(student, sindex) in scope.row.list" :key="student.accountId">
                    {{student.studentName}}
                    <span v-if="sindex < scope.row.list.length - 1"> 、</span>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </li>
          <!-- 文字解析 -->
          <li class="question-analysis__text"
              v-if="item.analyze &&
              item.analyze[0]  &&
              item.analyze[0].content &&
              item.analyze[0].content[0] &&
              item.analyze[0].content[0].content !== '' ||
              (item.analyze &&
              item.analyze[0] &&
              item.analyze[0].title !== '')">
            <span style="min-width: 110px">文字解析:</span>
            <!-- 理科 -->
            <div v-if="scienceArr.includes(Number(overviewData.subject_id))">
              <div
                v-for="(zitem, zindex) in item.analyze"
                :key="zindex"
                class="text-content"
              >
                <span v-for=" (citem, cindex) in zitem.content" :key="cindex">
                  <span v-katexHtml="citem.content"></span>
                </span>
                <span v-katexHtml="zitem.title"></span>
              </div>
            </div>
            <!-- 文科 -->
            <div v-else>
              <div
                v-for="(zitem, zindex) in item.analyze"
                :key="zindex"
                class="text-content"
              >
                <span v-katexUbb="htmlDeCode(zitem.title)"></span>
                <span v-katexUbb="htmlDeCode(zitem.content[0] && zitem.content[0].content)"></span>
              </div>
            </div>
          </li>
          <!-- 视频解析 -->
          <li
            class="question-analysis__videos"
            v-if="item.question_source && item.question_source.length > 0"
          >
            <p>视频解析:</p>
            <p
              class="video-content"
              @click.stop="videoOpen(item.question_source[0].source_url)"
            >
              <span>播放</span>
            </p>
          </li>
        </ul>
      </li>
    </nav>
    <div v-if="showQuestionList.length < 1" class="empty">
      <img src="../../images/emptyType.png" alt="" />
    </div>
    <!-- 视频弹框 -->
    <video-dialog :dialogVisible.sync="dialogVisible" :videoUrl="videoUrl" />
  </div>
</template>
<script>
import { getQuestionAnalysisDetail } from '@/api/pt';
import { htmlDecodeByRegExp } from '@/utils';
import _ from 'lodash';
import videoDialog from '../../lesson-prepare/components/video-dialog.vue';
import TopicContentHeader from './topic-content-header.vue';

export default {
  name: 'TopicContent',
  props: {
    questionList: {
      type: Array,
      default: () => [],
    },
    isAssignShow: {},
    type: {},
    overviewData: {
      type: Object,
      default: () => {},
    },
    changeData: {
      type: Object,
      default: () => { },
    },
  },
  components: {
    videoDialog,
    TopicContentHeader,
  },
  watch: {
    questionList: {
      handler() {
        this.showQuestionList = this.questionList;
      },
      immediate: true,
    },
    isAssignShow(val) {
      if (!val && this.type) {
        this.showQuestionList.forEach((item) => {
          this.$set(item, 'checkActive', false);
        });
        this.pitchOnLength = 0;
        this.checkShow = false;
      }
    },
  },
  data() {
    return {
      // total: 0, // 总数
      scienceArr: [2, 4, 5],
      cnText: ['正确', '错误'],
      enText: ['True', 'False'],
      isAudioPlaying: false,
      isPad: this.$route.query.spad,
      dialogVisible: false,
      questionUUid: '',
      videoUrl: '',
      checkShow: false,
      questionsBasket: [],
      currentQuestionid: '',
      showQuestionList: [],
      customColor: '#F56C6C',
      pitchOnLength: '',
      currentQuestionUuid: '',
    };
  },
  computed: {
    videoType() {
      return function video(val) {
        if (val) {
          val.some((item) => item.video_data.length > 0);
        }
      };
    },
    includesThisQuestion() {
      const { questionsBasket } = this.$store.state;
      return function includesThisQuestion(val) {
        const str = questionsBasket.some((item) => item.question_uuid === val.question_uuid);
        if (str) {
          return true;
        }
        return false;
      };
    },
  },
  methods: {
    changeArrange(type) {
      this.checkShow = type;
      if (!type) {
        this.showQuestionList.forEach((item) => {
          this.$set(item, 'checkActive', false);
        });
        this.pitchOnLength = 0;
      }
      if (this.pitchOnLength > 0) {
        const arr = this.showQuestionList.filter((item) => item.checkActive);
        this.$emit('layoutTopic', arr);
      }
    },
    questionName(question, show) {
      let name = '';
      if (question === 1 && show === '100') {
        name = '单选题';
      } else if (question === 2 && show === '101') {
        name = '多选题';
      } else if (question === 3 && show === '102') {
        name = '填空题';
      } else if (question === 3 && show === '103') {
        name = '判断题';
      } else if (question === 6 && show === '112') {
        name = '选词填空';
      }
      return name;
    },
    // 音频播放状态
    onPlay() {
      console.log('音频开始播放了');
      this.isAudioPlaying = true;
    },
    // 转换html字符串
    htmlDeCode(str) {
      return htmlDecodeByRegExp(str, 1);
    },
    // 音频暂停状态
    onPause() {
      console.log('音频暂停了');
      this.isAudioPlaying = false;
    },
    hide() {
      if (this.$refs.audio) {
        this.$refs.audio.forEach((item) => {
          item.pause();
        });
      }
    },
    controlAudio(index) {
      const id = `audio${index}`;
      if (this.currentQuestionUuid === index && this.isAudioPlaying) {
        this.isAudioPlaying = false;
        this.$refs.audio.forEach((item) => {
          if (item.id === id) {
            item.pause();
          }
        });
      } else if (this.currentQuestionUuid === index && !this.isAudioPlaying) {
        this.isAudioPlaying = true;
        this.$refs.audio.forEach((item) => {
          if (item.id === id) {
            item.play();
          }
        });
      } else if (this.currentQuestionUuid !== index && !this.isAudioPlaying) {
        this.currentQuestionUuid = index;
        this.isAudioPlaying = true;
        this.$refs.audio.forEach((item) => {
          if (item.id === id) {
            item.play();
          } else {
            item.pause();
          }
        });
      } else if (this.currentQuestionUuid !== index && this.isAudioPlaying) {
        this.currentQuestionUuid = index;
        this.$refs.audio.forEach((item) => {
          if (item.id === id) {
            item.play();
          } else {
            item.pause();
          }
        });
      }
    },
    videoOpen(val) {
      this.dialogVisible = true;
      this.videoUrl = val;
    },
    pitchOn(value) { // 选中
      this.$set(value, 'checkActive', true);
      this.pitchOnLength = this.showQuestionList.filter((item) => item.checkActive).length;
    },
    callOff(value) { // 未选中
      this.$set(value, 'checkActive', false);
    },
    openAnalysis(item) { // 打开解析
      this.$set(item, 'active', true);
      this.currentQuestionid = item.question_id;
      this.evaluateQuestionDetails(item);
    },
    jumpTopic(id) {
      this.showQuestionList.forEach((item) => {
        this.$set(item, 'active', false);
      });
      this.showQuestionList.forEach((item) => {
        if (id === item.question_id) {
          this.$set(item, 'active', true);
          this.evaluateQuestionDetails(item);
        }
      });
    },
    closeAnalysis(item) { // 关闭解析
      this.$set(item, 'active', false);
    },
    async evaluateQuestionDetails(item) { // 解析接口
      const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
      const res = await getQuestionAnalysisDetail({
        school_id: userInfo.campusId,
        class_id: this.changeData.class_id || this.overviewData.class_id,
        evaluate_id: this.changeData.evaluate_id || this.overviewData.evaluate_id,
        question_id: item.question_id,
      });
      if (res.code === 200) {
        const analyzes = _.get(res.data.questionDetail, 'analyze');
        const questionSource = _.get(res.data.questionDetail, 'question_source');
        const detailsList = _.get(res.data, 'questionAnswer');
        const { allTotalCnt } = res.data;
        const { allWrongCnt } = res.data;
        this.$set(item, 'analyze', analyzes);
        this.$set(item, 'question_source', questionSource);
        this.$set(item, 'detailsList', detailsList);
        this.$set(item, 'allWrongCnt', allWrongCnt);
        this.$set(item, 'allTotalCnt', allTotalCnt);
      }
    },
    openStudent(item, type) {
      if (type) {
        this.$set(item, 'isShow', false);
      } else {
        this.$set(item, 'isShow', true);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.question-content {
  min-height: 500px;
  width: 100%;
  position: relative;
  &__check {
    position: absolute;
    top: -2px;
    right: -4px;
  }
  .location {
    right: 15px;
    top: 10px;
    color: #FFA82D;
  }
  .content {
    min-height: 148px;
    border: 3px solid rgba(118, 194, 255, 0.14);
    border-radius: 12px;
    padding-top: 17px;
    margin-left: 28px;
    margin-top: 28px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    .title-uuid {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1989FA;
      text-decoration: underline;
    }
    &__title {
      padding: 5px;
      margin-left: 25px;
      display: inline-block;
      min-width: 89px;
      height: 24px;
      background: #f0f2f5;
      border-radius: 3px;
      border: 1px solid #d7dfec;
      font-size: 13px;
      color: #5a5e66;
      text-align: center;
      line-height: 24px;
    }
    &__count {
      margin: 16px 0;
      width: 584px;
      font-size: 15px;
      padding: 0 25px;
      color: #111f2c;
      line-height: 21px;
      display: flex;
    }
    &__option {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      border-bottom: 1px dashed #dce1eb;
      padding-bottom: 3px;
      font-size: 14px;
      div {
        display: flex;
        align-items: center;
      }
    }
    &__footer {
      width: 100%;
      height: 48px;
      line-height: 48px;
      display: flex;
      padding-left: 25px;
      box-sizing: border-box;
      justify-content: space-between;
      background: url("../../images/footerbg.png") no-repeat;
      background-size: 100% 100%;
      div {
        display: flex;
        align-items: center;
        p {
          margin-right: 20px;
          font-size: 14px;
        }
      }
      .footer__right {
        color: #1989fa;
        font-size: 14px;
      }
    }
  }
  .question-analysis {
    margin-left: 48px;
    margin-right: 20px;
    // min-height: 219px;
    border: 3px solid rgba(118, 194, 255, 0.14);
    border-radius: 12px;
    padding: 15px 20px;
    &__option {
      display: flex;
      justify-content: space-around;
      align-items: center;
      border-bottom: 1px dashed #dce1eb;
      padding-bottom: 20px;
      font-size: 14px;
      div {
        display: flex;
        align-items: center;
      }
    }
    &__answer {
      font-size: 15px !important;
      color: #000000;
      line-height: 53px;
      border-bottom: 1px dashed #dce1eb;
      display: flex;
      .completion {
        display: flex;
        align-items: center;
      }
      .right-answer {
        display: flex;
        justify-content: flex-start;
        color: #67c23a;
        margin-right: 10px;
        font-size: 15px !important;
      }
    }
    &__text {
      font-size: 15px;
      min-width: 120px;
      color: #000000;
      line-height: 53px;
      display: flex;
      .text-content {
        margin-top: 15px;
        p {
          line-height: 24px;
        }
      }
    }
    &__videos {
      margin-top: 17px;
      border-top: 1px dashed #dce1eb;
      font-size: 15px;
      color: #000000;
      height: 53px;
      display: flex;
      align-items: center;
      .video-content {
        display: inline-block;
        width: 84px;
        height: 28px;
        background: #ffa82d;
        border-radius: 14px;
        margin-left: 45px;
        line-height: 28px;
        span {
          font-size: 16px;
          display: inline-block;
          background: url("../../images/play_video.png") no-repeat left center;
          background-size: 24px 24px;
          box-sizing: border-box;
          padding-left: 32px;
          text-align: center;
          margin-left: 2px;
          color: #ffffff;
        }
      }
    }
  }
  .empty {
    img {
      width: 209px;
      height: 147px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 30px;
    }
  }
  .error {
    display: flex;
    margin-top: 10px;
    font-size: 16px;
    &-label {
      width: 110px;
      font-size: 18px;
      font-weight: 500;
    }
    .mr {
      margin-right: 10px;
      margin-left: 10px;
    }
    &-student {
      margin-top: 15px;
      position: relative;
      min-width: 400px;
      max-width: 700px;
      line-height: 24px;
      padding: 18px 20px;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      background-color: #fff;
      box-shadow: 0 2px 12px 0 ;
      word-break: break-all;
      .top  {
        position: absolute;
        color: #fff;
        font-size: 20px;
        top: -15px;
      }
    }
    &-answer {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      margin: 15px;
      /deep/ {
        .el-progress {
          flex: 1;
        }
        .el-icon-arrow-up:before {
          content: "\e6e1";
        }
      }
    }
  }
  .error-topic {
    font-size: 18px;
    margin-top: 10px;
  }
}
.fx-1 {
  flex: 1;
}
.judge {
  min-width: 60px;
  text-align: center;
  padding: 5px;
  line-height: 28px;
  border: 1px solid #ccc;
  border-radius: 28px;
}
.content__audio {
      margin-left: 25px;
      margin-bottom: 16px;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: #f7ca08;
      .audio-pause {
        width: 36px;
        height: 36px;
        // border-radius: 50%;
        background: url("../../images/audio_pause.png") no-repeat center center;
        background-size: 22px 15px;
        &.voice-playing {
          background: url("../../images/audio_playing.gif") no-repeat center
            center;
          background-size: 22px 15px;
        }
      }
    }
</style>
